import "core-js/modules/es.array.includes";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import dayjs from 'dayjs';
export default {
  data: function data() {
    return {
      time: '09:00:00',
      tabData: {}
    };
  },
  methods: {
    dataBind: function dataBind(item) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$api.realTimeData(item);

              case 2:
                data = _context.sent;

                _this.setTabData(data);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    setCents: function setCents(val) {
      if (typeof val === 'number') {
        return val.toFixed(0).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
      }
    },
    setFiler: function setFiler(data) {
      //不需要添加百分号
      var keys = ['visitors', 'visitorsYesterday', 'browses', 'browsesYesterday', 'fans', 'addCarts', 'orderPeoples', 'orderPeoplesYesterday', 'orderPeoplesYesterday', 'orders', 'ordersYesterday', 'orderGoods', 'orderGoodsYesterday', 'orderAmounts', 'orderAmountsYesterday', 'customerPrice', 'customerPriceYesterday'];

      for (var key in data) {
        if (keys.includes(key)) {
          data[key] = this.setCents(data[key]);
        } else {
          if (typeof data[key] === 'number') {
            data[key] = data[key] + '%';
          }
        }
      }

      return data;
    },
    setTabData: function setTabData(data) {
      var item = this.setFiler(_objectSpread({}, data));
      var list = [{
        label: '访客数',
        num: item.visitors,
        children: [{
          label: '昨天23:30',
          num: item.visitorsYesterday
        }, {
          label: '较昨天23:30',
          num: item.visitorsMoreThenYesterday
        }, {
          label: '占昨天全天',
          num: item.visitorsCompareYesterday
        } // { label: '占全部渠道', num: item.visitorsCompareYesterday }
        ]
      }, {
        label: '浏览量',
        num: item.browses,
        children: [{
          label: '昨天23:30',
          num: item.browsesYesterday
        }, {
          label: '较昨天23:30',
          num: item.browsesMoreThenYesterday
        }, {
          label: '占昨天全天',
          num: item.browsesCompareYesterday
        } // { label: '占全部渠道', num: item.browsesCompareYesterday }
        ]
      }, {
        label: '成交转化率',
        num: item.orderRate,
        children: [{
          label: '昨天全天',
          num: item.orderRateYesterday
        }, {
          label: '较前一天',
          num: item.orderRateMoreThenYesterday
        }]
      }, {
        label: '店铺累计关注人数',
        num: item.fans,
        children: []
      }, {
        label: '今日加购人数',
        num: item.addCarts,
        children: []
      }, {
        label: '成交客户数',
        num: item.orderPeoples,
        children: [{
          label: '昨天23:30',
          num: item.orderPeoplesYesterday
        }, {
          label: '较昨天23:30',
          num: item.orderPeoplesMoreThenYesterday
        }, {
          label: '占昨天全天',
          num: item.orderPeoplesCompareYesterday
        } // { label: '占全部渠道', num: item.orderPeoplesCompareYesterday }
        ]
      }, {
        label: '成交单量',
        num: item.orders,
        children: [{
          label: '昨天23:30',
          num: item.ordersYesterday
        }, {
          label: '较昨天23:30',
          num: item.ordersMoreThenYesterday
        }, {
          label: '占昨天全天',
          num: item.ordersCompareYesterday
        } // { label: '占全部渠道', num: item.ordersCompareYesterday }
        ]
      }, {
        label: '成交商品件数',
        num: item.orderGoods,
        children: [{
          label: '昨天23:30',
          num: item.orderGoodsYesterday
        }, {
          label: '较昨天23:30',
          num: item.orderGoodsMoreThenYesterday
        }, {
          label: '占昨天全天',
          num: item.orderGoodsCompareYesterday
        } // { label: '占全部渠道', num: item.orderGoodsCompareYesterday }
        ]
      }, {
        label: '成交金额',
        num: '￥' + item.orderAmounts,
        children: [{
          label: '昨天23:30',
          num: '￥' + item.orderAmountsYesterday
        }, {
          label: '较昨天23:30',
          num: item.orderAmountsMoreThenYesterday
        }, {
          label: '占昨天全天',
          num: item.orderAmountsCompareYesterday
        } // { label: '占全部渠道', num: item.orderAmountsCompareYesterday }
        ]
      }, {
        label: '客单价',
        num: item.customerPrice,
        children: [{
          label: '昨天23:30',
          num: item.customerPriceYesterday
        }, {
          label: '较昨天23:30',
          num: item.customerPriceMoreThenYesterday
        }, {
          label: '占昨天全天',
          num: item.customerPriceCompareYesterday
        } // { label: '占全部渠道', num: item.customerPriceCompareYesterday }
        ]
      }];
      this.tabData = list;
      this.time = dayjs().format('HH:mm:ss');
    }
  },
  created: function created() {
    this.dataBind();
  }
};